var map = {
	"./a-global-data-consensus": 205,
	"./a-global-data-consensus.json": 205,
	"./balancing-data-protection-and-competition": 206,
	"./balancing-data-protection-and-competition.json": 206,
	"./citizen-science-protects-fishing-in-amazon": 207,
	"./citizen-science-protects-fishing-in-amazon.json": 207,
	"./community-led-data-collection-in-rural-india": 208,
	"./community-led-data-collection-in-rural-india.json": 208,
	"./covid-19-increased-data-consumption": 209,
	"./covid-19-increased-data-consumption.json": 209,
	"./covid-19-the-social-contract-in-action": 210,
	"./covid-19-the-social-contract-in-action.json": 210,
	"./developing-data-to-end-violence-against-women-and-girls": 211,
	"./developing-data-to-end-violence-against-women-and-girls.json": 211,
	"./environment-datas-carbon-footprint": 212,
	"./environment-datas-carbon-footprint.json": 212,
	"./governance-international-cooperation": 213,
	"./governance-international-cooperation.json": 213,
	"./home": 168,
	"./home.json": 168,
	"./repurposing-data-to-make-roads-safer": 214,
	"./repurposing-data-to-make-roads-safer.json": 214,
	"./the-potential-of-open-data-to-help-businesses": 215,
	"./the-potential-of-open-data-to-help-businesses.json": 215,
	"./the-role-of-international-organizations-in-improving-public-intent-data": 216,
	"./the-role-of-international-organizations-in-improving-public-intent-data.json": 216,
	"./using-data-to-manage-debt-during-the-COVID-19-pandemic": 217,
	"./using-data-to-manage-debt-during-the-COVID-19-pandemic.json": 217,
	"./weather-data-valuable-for-development": 218,
	"./weather-data-valuable-for-development.json": 218,
	"./who-owns-personal-data": 219,
	"./who-owns-personal-data.json": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;